import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Home';
import Services from './Services';

function App() {
  return (
    <div className="App">



     <div className=' '> 
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='home' element={<Home/>} />
          <Route path='services' element={<Services/>} />
        </Routes>
     </div>


    </div>
  );
}

export default App;
